import { isEmpty } from './isEmpty';

export const findTextNodeInElement = (node: HTMLElement): HTMLElement => {
  if (node.nodeType === Node.TEXT_NODE || isEmpty(node.children)) {
    return node;
  }

  return findTextNodeInElement(node.children[0] as HTMLElement);
};
